import React from 'react'

const PrivacyPolicySec = (props) => {
    const { data } = props
    return (
        <>
            <section className="privacy-terms-conditions-page">
                <div className="container">
                    <div className="row">
                        <div className="col-lg-12 p-0">
                            <div className="card">
                                <div dangerouslySetInnerHTML={{ __html: `${data}` }} />
                            </div>
                        </div>
                    </div>
                </div>
            </section >
        </>
    )
}

export default PrivacyPolicySec